import api from '@/utils/api';
import {
    GET_BY_CUSTOMER,
    UPDATE_SPECIFIC_ORTHODONTIC_PLAN,
} from './types';
import { NotificationManager } from 'react-notifications';

export const getByCustomer = (filter, customerId) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/orthodontic-plans/customer/${customerId}`, { params: filter }).then(res => {
            dispatch({
                type: GET_BY_CUSTOMER,
                payload: res.data.data
            });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            //NotificationManager.error(err.response?.data?.msg);
            reject(err);
        })
    })
}

export const updateOrthodonticPlan = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/orthodontic-plans/customer/${customerId}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_ORTHODONTIC_PLAN, payload: res.data.data });
            NotificationManager.success(res.data.msg);
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        })
    })
}

export const approveOrthodonticPlan = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/orthodontic-plans/approve/${id}`).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_ORTHODONTIC_PLAN, payload: res.data.data });
            NotificationManager.success(res.data.msg);
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        });
    });
};

export const unapproveOrthodonticPlan = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/orthodontic-plans/unapprove/${id}`).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_ORTHODONTIC_PLAN, payload: res.data.data });
            NotificationManager.success(res.data.msg);
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        });
    });
};

